import React, { Component } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Grid,
  Container,
} from "@material-ui/core";
import { Menu, Tabs } from "antd";
import { PostData } from "../../api/service";

import GeneralNotificationShort from "../Department/GeneralNotificationShort";
class ItepFacilityDescription extends Component {
  state = {
    active: 0,
  };
  render() {
    return (
      <div style={{ marginTop: "" }}>
        {this.props.type == "content" && (
         <div style={{ paddingBottom: "5em", paddingTop: "2em" }}>
            <Library type={this.props.code} title={this.props.title} />
          </div>
        )}

        {this.props.type == "file" && (
          <div style={{ paddingBottom: "5em", paddingTop: "2em" }}>
            <GeneralNotificationShort
              dept_code="PRAG"
              type={this.props.code}
              title={this.props.title}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ItepFacilityDescription;

export const Library = (props) => {
  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    __loadFile();
  }, [props.type]);

  function __loadFile() {
    let d = {
      dept_code: "PRAG",
      type: props.type,
      year: "",
    };

    PostData(`/getnoticesbytypedept`, d).then((resp) => {
      setData(resp);
      setIsLoaded(true);
    });
  }

  return (
    <>
      <Container className="mb-5">
        <div className="text-justify">
          <Typography
            variant="h5"
            style={{ margin: "1em 0", fontWeight: 700 }}
            gutterBottom
          >
            {props.title}
          </Typography>

          {isLoaded && (
            <div>
              {Array.isArray(data) &&
                data.map((el, index) => (
                  <div key={index}>
                    <Typography variant="body1" gutterBottom>
                      <p
                        variant="body1"
                        dangerouslySetInnerHTML={{ __html: el.description }}
                      />
                    </Typography>
                  </div>
                ))}
            </div>
          )}
        </div>
      </Container>
    </>
  );
};

const { TabPane } = Tabs;
